var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-dialog',{attrs:{"text":"Duplicate Name","show-dialog":_vm.showDialog,"on-close":_vm.handleClose,"on-primary":_vm.handleClose,"primary-button-text":"OK","width":340}},[_c('asc-duplicate-name',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }